import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import RowWrapper from './RowWrapper';
const ItemRow = ({ rowIdx, width, height, scrollOptims, children, rowAlign })=>{
    let rowStyle = {};
    if (rowAlign) {
        const settingToCss = {
            left: 'flex-start',
            right: 'flex-end',
            center: 'center'
        };
        rowStyle = {
            display: 'flex',
            justifyContent: settingToCss[rowAlign]
        };
    }
    return /*#__PURE__*/ React.createElement(RowWrapper, {
        style: _object_spread({
            width: width,
            containIntrinsicSize: `${width}px ${height}px`,
            contentVisibility: scrollOptims ? 'auto' : 'visible'
        }, rowStyle),
        "data-testid": `${BiDataHook.CONTENT_ROW_IDX}-${rowIdx}`
    }, children);
};
ItemRow.displayName = 'ItemRow';
export default ItemRow;
